class MonitoringStore {
  private totalRequestTime: number;

  private requestCount: number;

  private subscribers: (() => void)[] = [];

  private storageKey = 'recentMonitoringData';

  private recentRequests: number[] = []; // Stores the durations of the latest 100 requests

  private maxRecentRequests = 100; // Limit to the last 100 requests

  constructor() {
    if (typeof window !== 'undefined' && typeof localStorage !== 'undefined') {
      const storedData = localStorage.getItem(this.storageKey);
      if (storedData) {
        const { recentRequests } = JSON.parse(storedData);
        this.recentRequests = recentRequests || [];
      } else {
        this.recentRequests = [];
      }
      this.totalRequestTime = this.recentRequests.reduce((sum, time) => sum + time, 0);
      this.requestCount = this.recentRequests.length;
    } else {
      this.recentRequests = [];
      this.totalRequestTime = 0;
      this.requestCount = 0;
    }
  }

  getMetrics() {
    const recentRequestTime = this.recentRequests.reduce((sum, time) => sum + time, 0);
    const recentAverage = this.recentRequests.length > 0 ? recentRequestTime / this.recentRequests.length : 0;

    return {
      totalRequestTime: this.totalRequestTime,
      requestCount: this.requestCount,
      averageRequestTime: this.requestCount > 0 ? this.totalRequestTime / this.requestCount : 0,
      recentAverageRequestTime: recentAverage, // Average of the latest 100 requests
    };
  }

  updateMetrics(requestTime: number) {
    this.recentRequests.push(requestTime);

    // Remove the oldest request if the limit exceeds 100
    if (this.recentRequests.length > this.maxRecentRequests) {
      this.recentRequests.shift(); // Remove the oldest request time
    }

    // Update total request time and count based on the sliding window
    this.totalRequestTime = this.recentRequests.reduce((sum, time) => sum + time, 0);
    this.requestCount = this.recentRequests.length;

    if (typeof window !== 'undefined' && typeof localStorage !== 'undefined') {
      localStorage.setItem(
        this.storageKey,
        JSON.stringify({
          recentRequests: this.recentRequests,
        })
      );
    }

    this.notifySubscribers();
  }

  subscribe(callback: () => void) {
    this.subscribers.push(callback);
    return () => {
      this.subscribers = this.subscribers.filter((sub) => sub !== callback);
    };
  }

  private notifySubscribers() {
    this.subscribers.forEach((callback) => callback());
  }
}

const monitoringStore = new MonitoringStore();
export default monitoringStore;
